export default "# Steps 步骤条\r\n\r\n引导用户按照流程完成任务的分步导航条，可根据实际应用场景设定步骤，步骤不得少于 2 步。\r\n\r\n\r\n## 何时使用\r\n\r\n- ...。";